"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.array.splice.js");

var _main = _interopRequireDefault(require("./src/main.js"));

var _lodash = _interopRequireDefault(require("lodash"));

var _dom = require("element-ui/lib/utils/dom");

var _dom2 = require("sk-ui/lib/utils/dom");

/* istanbul ignore next */
_main["default"].install = function (Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  _main["default"].appContext = opts.app;
  Vue.prototype.$dialog = dialog;
  Vue.component(_main["default"].name, _main["default"]);
};

var TAB_KEY_CODE = 9;
var caches = [];
var instances = [];
var currentInstance = null;

var hanldeKeydown = function hanldeKeydown(event) {
  var target = event.target;
  var keyCode = event.keyCode;

  if (keyCode === TAB_KEY_CODE) {
    var next = (0, _dom2.getNextTabElement)(target, false);

    if (currentInstance && !currentInstance.component.$el.contains(next)) {
      event.preventDefault();
      (0, _dom2.getNextTabElement)(currentInstance.component.$el, false).focus();
    }
  }
};

(0, _dom.on)(window, 'keydown', hanldeKeydown);

function getDailogInstance() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var exist = _lodash["default"].findIndex(caches, {
    title: options.props.title
  });

  if (exist === -1) {
    var opts = Object.assign({
      removeCurDialog: function removeCurDialog(title) {
        var index = caches.findIndex(function (cache) {
          return cache.title === title;
        });

        if (index >= 0) {
          caches.splice(index, 1);
          instances.splice(index, 1);
          currentInstance = instances.length > 0 ? instances[instances.length - 1] : null;
        }
      }
    }, options);

    var dialogInstance = _main["default"].call(this, opts);

    caches.push({
      title: options.props.title
    });
    return dialogInstance;
  }
}

function dialog() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var instance = getDailogInstance.call(this, props);
  currentInstance = instance;

  if (instance) {
    instance.show(props);
  }

  instances.push(instance);
  return instance;
}

dialog.removeAll = function () {
  for (var i = instances.length - 1; i >= 0; i--) {
    instances[i].remove();
  }
};

_main["default"].use = function (app) {
  _main["default"].appContext = app;
};

_main["default"].instanceMethod = dialog;
var _default = _main["default"];
exports["default"] = _default;